import type { Visualize3dComponent } from './visualize3d-component';
import type { QModelParameter } from '../models/q-model-parameter';
import type { Visualize3dComponentCreator } from './visualize3d-component-creator';
import { QModelTag } from '../models/q-model-tag';

export interface QModelComponent extends Visualize3dComponent {
  id: string;
  parameters: QModelParameter[];
  tags: QModelTag[];
  detailMode: number;
  lodLevel: number;
  platform: number;
  viewMode: number;
  dimensionLineMode: number;
  calculationResolution: number;
}

export const qmodelComponentCreator: Visualize3dComponentCreator<QModelComponent> = {
  createComponent: createQModel,
};

/**
 * Creates new instance of QModel component
 */
export function createQModel(): QModelComponent {
  return {
    $type: 'MagiCADCore.Visualize3D.QModel.DataTransfer.QModelDto, MagiCADCore.Visualize3D.QModel',
    type: 'QModel',
    id: null,
    parameters: new Array<QModelParameter>(),
    tags: new Array<QModelTag>(),
    detailMode: 0,
    lodLevel: 0,
    platform: 0,
    viewMode: 0,
    dimensionLineMode: 0,
    calculationResolution: 1,
  };
}

/**
 * Set QModel parameter value
 * @param qModel QModel
 * @param key Parameter key
 * @param value Parameter value
 */
export function setParameter(qModel: QModelComponent, key: string, value: unknown): void {
  const element = getParameter(qModel, key);
  if (!element) {
    appendParameter(qModel, key, value);
    return;
  }
  element.value = value;
}

/**
 * Append new parameter to QModel
 * @param qModel QModel
 * @param key Parameter key
 * @param value Parameter value
 */
export function appendParameter(qModel: QModelComponent, key: string, value: unknown): void {
  qModel.parameters.push({ key, value });
}

/**
 * Get QModel parameter by key
 * @param qModel QModel
 * @param key Parameter key
 */
export function getParameter(qModel: QModelComponent, key: string): QModelParameter {
  return qModel.parameters.find(p => p.key === key);
}

/**
 * Set QModel tag value
 * @param qModel QModel
 * @param key Tag key
 * @param value Tag value
 */
export function setTag(qModel: QModelComponent, key: string, value: string): void {
  const element = getTag(qModel, key);
  if (!element) {
    appendTag(qModel, key, value);
    return;
  }
  element.value = value;
}

/**
 * Append new tag to QModel
 * @param qModel QModel
 * @param key Tag key
 * @param value Tag value
 */
export function appendTag(qModel: QModelComponent, key: string, value: string): void {
  qModel.tags.push({ key, value });
}

/**
 * Get QModel tag by key
 * @param qModel QModel
 * @param key Tag key
 */
export function getTag(qModel: QModelComponent, key: string): QModelTag {
  return qModel.tags.find(p => p.key === key);
}
